export const AVAILABLE_SPORT_IMAGES = [
  'americanfootball',
  'australianfootball',
  'badminton',
  'baseball',
  'basketball',
  'beachfootball',
  'beachhandball',
  'beachvolleyball',
  'boxing',
  'cricket',
  'curling',
  'default',
  'futsal',
  'handball',
  'bandy',
  'icehockey',
  'mma',
  'snooker',
  'soccer',
  'tabletennis',
  'tennis',
  'volleyball',
  'waterpolo',
  'pistolshooting',
  'pistolhead2head',
  'archeryh2h',
  'compoundarchery',
  'archery',
  'basketballshots'
];
